module.exports = __webpack_public_path__ + "static/snow-forecast-head-116066473724d069e7a4a1053adfe050.jpg";